import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { tagTypeSubscriptionsEdit_template } from "../components/templates/tagTypeSubscriptionsEdit_template";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class tag_type_subscriptions_edit extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected editForm: tagTypeSubscriptionsEdit_template;

    protected getModuleName(){

        return "tag_type_subscriptions_edit";
    }

    buildContent() : Array<Element>{

        let vnApp = this.getVnAppZone().app;
        let roles = vnApp.loggedUser.user.valnet_user.roles;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Tag Dataset Subscription Edit");

        this.editForm = new tagTypeSubscriptionsEdit_template(this.getModuleName(), this.viewModel, this);

        return [this.editForm.build()];
    }

    public getFormData() {
        let usrReq_url: string = `/api/brand/${this.getBrandID()}/tag/types/subscriptions/get/${this.getDatasetID()}`;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetDataReturn;
        if(this.getDatasetID()) {
            this.XHRHdl.execute();
        }
    }

    public onGetDataReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                obj.editForm.setTagDatasetSubscription(JSON.parse(req.request.response));
            });
        }
    }

    public fillPage() : void{

        let idBrand = this.getBrandID();
        if (idBrand) {
            this.editForm.setIdBrand(idBrand);
        }
        this.getFormData();
    }


    protected cancel(){
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Tag type dataset changes cancelled!");
        page(`/brand/${this.getVnAppZone().app.params.idBrand}/categorization/tag-type-subscriptions/`);
    }

    protected save(vm){
        this.editForm.activateLoading();

        if(this.XHRHdl instanceof XMLHttpRequestHandler) {
            this.XHRHdl.cancelAndReset();
        }

        let usrReq_url: string = `/api/brand/${this.getBrandID()}/tag/types/subscriptions/save/`;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(vm)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST; // Set the mode to POST

        this.XHRHdl.onReadyStateFunction = this.onSaveReturn;
        this.XHRHdl.execute();
    }

    protected onSaveReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                if(req.request.status == 200) {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Tag type dataset saved!");
                    page(`/brand/${obj.getVnAppZone().app.params.idBrand}/categorization/tag-type-subscriptions/`);
                }
            });
            if(req.request.status != 200) {
                obj.editForm.deactivateLoading();
            }
        }
    }

    public getDatasetTagTypeInfo(idDataset): void {
        let usrReq_url: string = `/api/brand/${this.getBrandID()}/tag/types/subscriptions/get/${idDataset}`;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetDataReturn;
        this.XHRHdl.execute();
    }

    public ongetDatasetTagTypeInfoReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                obj.editForm.setTagDatasetSubscription(JSON.parse(req.request.response));
            });
        }
    }

    private executeXHR(idHdl: string, url: string, params: any, onReadyStateFunction: any) {
        if(this.XHRHdl[idHdl]) {
            this.XHRHdl[idHdl].cancelAndReset();
        }

        this.XHRHdl[idHdl] = new XMLHttpRequestHandler(url, params, this);
        this.XHRHdl[idHdl].onReadyStateFunction = onReadyStateFunction;
        this.XHRHdl[idHdl].execute();
    }

    public getDatasetSuggestion(keyword, idElement) {

        // LOADING : starts
        this.loadingIn(this.editForm.datasetFilterAutocomplete.builtTemplate);

        let usrReq_url: string = `/api/brand/${this.getBrandID()}/search/tag/dataset/`;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON({keyword: keyword})]);

        this.executeXHR('getDatasetSuggestion', usrReq_url, usrReq_params, this.onDatasetOptionsReturn);
    }

    protected onDatasetOptionsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response.data.templateTypes) {

                    let templateOptions = response.data.templateTypes;
                    obj.editForm.setDatasetOptions(templateOptions);
                }

            });
        }
    }

    protected getSuggestions(keyword, idSourceElement) {
        if (idSourceElement == "datasetFilterAutocomplete") {

            this.getDatasetSuggestion(keyword, 5);
        }
    }

    protected onAutocompleteInputClick(idElement) {

        if ( idElement == "datasetFilterAutocomplete" )
        {

            let filterTypes = this.editForm.datasetFilterAutocomplete.getTemplateViewModel();

            if (filterTypes.addNewSelected())
            {
                this.editForm.datasetFilterAutocomplete.setOptions([]);

            }
        }
    }

    protected onAutocompleteOptionChange(idElement) {

        if (idElement == "datasetFilterAutocomplete") {
            let dataset = this.editForm.datasetFilterAutocomplete.getTemplateViewModel().optionObj();
            if (dataset) {
                this.editForm.getTemplateViewModel().idDataset(dataset.id);
            }
        }
    }

    protected onAutocompleteInputClear() {
        this.editForm.getTemplateViewModel().idDataset(null);
    }

    private getBrandID() {
        return this.getVnAppZone().getApp().params.idBrand;
    }

    private getDatasetID() {
        return this.getVnAppZone().getApp().params.idDataset;
    }
}


// WEBPACK FOOTER //
// ./js/modules/tag_type_subscriptions_edit.ts